module.exports = __webpack_public_path__ + "img/box7-9.daff6a4f.png";